/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterData
 */
export interface FilterData {
    /**
     * 
     * @type {boolean}
     * @memberof FilterData
     */
    onlyCpr: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FilterData
     */
    dateFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilterData
     */
    dateTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof FilterData
     */
    organizationalUnitId?: string;
}

export function FilterDataFromJSON(json: any): FilterData {
    return FilterDataFromJSONTyped(json, false);
}

export function FilterDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'onlyCpr': json['onlyCpr'],
        'dateFrom': !exists(json, 'dateFrom') ? undefined : (new Date(json['dateFrom'])),
        'dateTo': !exists(json, 'dateTo') ? undefined : (new Date(json['dateTo'])),
        'organizationalUnitId': !exists(json, 'organizationalUnitId') ? undefined : json['organizationalUnitId'],
    };
}

export function FilterDataToJSON(value?: FilterData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'onlyCpr': value.onlyCpr,
        'dateFrom': value.dateFrom === undefined ? undefined : (value.dateFrom.toISOString()),
        'dateTo': value.dateTo === undefined ? undefined : (value.dateTo.toISOString()),
        'organizationalUnitId': value.organizationalUnitId,
    };
}


